/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {getDefaultSavedMapView} from '@ion/dls/src/maps/helpers/MapViewUtils';
import {SavedMapViewType} from '@ion/dls/src/types/types';

/**
 * @useSavedMapViews
 * Hook to return the default saved MapView
 *
 *  ```typescript
 *   import {useMapViewExtent} from '@/routes/tracking/hooks';
 *
 *   const {getDefaultMapView} = useMapViewExtent();
 *  ```
 */
export const useSavedMapViews = () => {
  const getDefaultMapView = (savedMapViews: SavedMapViewType[]) => {
    const defaultMapView = getDefaultSavedMapView(savedMapViews);
    return defaultMapView || null;
  };
  return getDefaultMapView;
};
